/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-script-url */

import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { RoleContext } from '../../store/role-context-provider'
import Buttons from '../buttons/buttons'
import './accordions.css'

interface Props {
  IsEdit?: any
  ItemId?: any
  accordionName?: string
  accordionitemclass?: any
  actions?: any
  'aria-label'?: any
  className: any
  content?: any
  contentclassName?: any
  count?: any
  dataobj?: any
  defaultActivekey?: any
  dividerClass?: any
  expandedIndex?: any
  extras?: any
  extras1?: any
  extras1Class?: any
  extrasClass?: any
  headerextras?: any
  icon?: any
  inputProps: any
  isClick?: any
  isExpandAll?: any
  isFolder?: boolean
  isSettings?: boolean
  items: any
  kpicode?: any
  label?: any
  renderHtml?: any
  responseObj?: any
  setExpandDetailsAccordion?: any
  setheight?: any
  statukpis?: any
  titleClass?: any
  titleIcon?: any
  titleclassName?: any
  titlecollapsedIcon?: any
  titlecontentclassName?: any
}
const Accordions = (props: Props) => {
  const {
    isCPOwner,
    isCSS,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isRegAFOwner,
    isSectionChief,
    isSectionOwner,
    isSupervisor,
    isTechnician,
    mpfSection,
  } = useContext(RoleContext)
  const location = useLocation()
  const currentPath = location.pathname
  const splitLocation = currentPath.split('/')

  const detailViewLocation = splitLocation[1]
  const { guid } = useParams()
  const createInquiryPath = guid ? `/createinquiry/${guid}` : '/createinquiry'
  const detailViewPath = guid ? `/${detailViewLocation}/${guid}` : `/${detailViewLocation}`
  const page =
    (currentPath === detailViewPath || currentPath === createInquiryPath) &&
      currentPath !== '/settings'
      ? [] || props?.expandedIndex
      : 0
  const [clicked, setClicked] = useState<any>(page)
  const [expandAll, setExpandAll] = useState(false)

  const toggle = (index: number, value: any) => {
    if (props?.setExpandDetailsAccordion) props?.setExpandDetailsAccordion(false)
    setExpandAll(false)
    // props?.IsEdit(false)
    if (props?.isSettings) {
      props?.dataobj(index)
    }
    if (props?.setheight) {
      props?.setheight(true)
    }
    if (page) {
      if (clicked?.includes(index) && value === 'expanded') {
        setClicked((prevClicked: any) => prevClicked?.filter((item: any) => item !== index))
      } else if (value !== 'expanded') {
        setClicked((prevClicked: any) => [...prevClicked, index])
      } else {
        setClicked(index)
      }
    } else {
      if ((clicked === index || expandAll) && value === 'expanded') {
        setExpandAll(false)
        return setClicked(null)
      } else if (value !== 'expanded') {
        return setClicked(index)
      }
      return setClicked(index)
    }
  }

  const determineVisibility = (
    kpiTitle: string,
    userSections: string[] = [],
    accordionName?: string,
    activeRoles: {
      isCPOwner?: boolean
      isLeadership?: boolean
      isMAJCOMOwner?: boolean
      isMPFOwner?: boolean
      isRegAFOwner?: boolean
      isSectionChief?: boolean
      isSectionOwner?: boolean
      isSupervisor?: boolean
      isTechnician?: boolean
    } = {}
  ) => {
    if (accordionName !== 'kpis') return true

    const {
      isCPOwner,
      isLeadership,
      isMAJCOMOwner,
      isMPFOwner,
      isRegAFOwner,
      isSectionChief,
      isSectionOwner,
      isSupervisor,
      isTechnician,
    } = activeRoles

    const canSeeEverything = [
      isCPOwner,
      isLeadership,
      isMPFOwner,
      isRegAFOwner,
      isCSS,
      isMAJCOMOwner,
    ].some(Boolean)
    const canSeeSomeThings = [isSectionChief, isSectionOwner, isSupervisor, isTechnician].some(
      Boolean
    )

    const normalizedKpiTitle = kpiTitle.toLowerCase().replace(' ', '')
    const currentSections = userSections.map((section) => {
      return section.toLowerCase().replace(' ', '')
    })

    const doSectionsMatchKPI = currentSections.includes(normalizedKpiTitle)

    if (canSeeEverything) return true

    const isResponseKPI = ['responsepending', 'responserequested'].includes(normalizedKpiTitle)

    if (canSeeSomeThings) {
      if (doSectionsMatchKPI && !isResponseKPI) {
        return true
      }
      if (
        isResponseKPI &&
        normalizedKpiTitle === 'responserequested' &&
        props.responseObj.isRequested
      ) {
        return true
      }
      if (
        isResponseKPI &&
        normalizedKpiTitle === 'responsepending' &&
        props.responseObj.isPending
      ) {
        return true
      }
    }
  }

  useEffect(() => {
    if (props?.ItemId?.ID) {
      setClicked([props?.ItemId?.ID])
    } else if (props?.ItemId) {
      setClicked(props?.ItemId)
    } else if (props?.ItemId === null && !props?.isFolder) {
      setExpandAll(false)
      setClicked([0])
    }
  }, [props?.ItemId])
  useEffect(() => {
    setExpandAll(props?.isExpandAll)
  }, [props?.isExpandAll])

  useEffect(() => {
    if (page === 0) {
      props?.isClick ? setClicked([2]) : setClicked([1])
    }
    //selects accordion to open/close based on inquiry details primarily
  }, [props?.isClick])
  useEffect(() => {
    if (props?.expandedIndex && props?.expandedIndex?.length > 0) {
      setClicked([...props.expandedIndex])
    }
  }, [props?.expandedIndex])
  return (
    <div>
      <div className={props?.className}>
        {props?.items.length > 0 ? (
          props?.items?.map((item: any, index: number) => {
            const options: any = {}
            if (item.kpicode) {
              options['status-kpis'] = item.kpicode
            }
            return (
              <>
                {determineVisibility(item.title, mpfSection, props.accordionName, {
                  isCPOwner,
                  isLeadership,
                  isMAJCOMOwner,
                  isMPFOwner,
                  isRegAFOwner,
                  isSectionChief,
                  isSectionOwner,
                  isSupervisor,
                  isTechnician,
                }) && (
                    <div
                      className={
                        page
                          ? (Array.isArray(clicked) && clicked?.includes(item?.Id)) || expandAll
                            ? props?.accordionitemclass
                              ? `accordion-item active ${props?.accordionitemclass}`
                              : 'accordion-item active'
                            : props?.accordionitemclass
                              ? `accordion-item ${props?.accordionitemclass}`
                              : 'accordion-item'
                          : clicked === item?.Id || expandAll
                            ? props?.accordionitemclass
                              ? `accordion-item active ${props?.accordionitemclass}`
                              : 'accordion-item active'
                            : props?.accordionitemclass
                              ? `accordion-item ${props?.accordionitemclass}`
                              : 'accordion-item'
                      }
                      key={item?.Id}
                    >
                      <div className={props?.inputProps?.accordionheadClass}>
                        <div
                          className={
                            props?.inputProps?.className
                              ? `accordion-head ${props?.inputProps?.className} d-flex align-items-center flex-row flex-nowrap ps-1 m-1`
                              : 'accordion-head'
                          }
                          key={item?.Id}
                          onClick={() =>
                            toggle(
                              item?.Id,
                              page
                                ? Array.isArray(clicked) && clicked?.includes(item?.Id)
                                  ? 'expanded'
                                  : 'collapsed'
                                : clicked === item?.Id || expandAll
                                  ? 'expanded'
                                  : 'collapsed'
                            )
                          }
                          onKeyDown={(e) =>
                            e.key === 'Enter' &&
                            toggle(
                              item?.Id,
                              page
                                ? Array.isArray(clicked) && clicked?.includes(item?.Id)
                                  ? 'expanded'
                                  : 'collapsed'
                                : clicked === item?.Id || expandAll
                                  ? 'expanded'
                                  : 'collapsed'
                            )
                          }
                          tabIndex={0}
                           title={item?.titlename || item?.title}
                          {...options}
                        >
                          {item?.extras && (
                            <span className='border-right1 px-3 py-2 poppins-bold font-16 '>
                              {item?.extras}
                            </span>
                          )}{' '}
                          {props?.titleIcon && (
                            <span
                              className={
                                page
                                  ? Array.isArray(clicked) && clicked?.includes(item?.Id)
                                    ? props?.titleIcon
                                    : props?.titlecollapsedIcon
                                  : clicked === item?.Id
                                    ? props?.titleIcon
                                    : props?.titlecollapsedIcon
                              }
                            ></span>
                          )}{' '}
                          <span  className={props?.titleClass}>{item?.title}</span>{' '}
                          {item?.count > -1 && <span className={props?.count}>{item?.count}</span>}
                          {props?.icon && (
                            <span
                              className={
                                page
                                  ? Array.isArray(clicked) && clicked?.includes(item?.Id)
                                    ? props?.icon
                                    : `rotate180 ${props?.icon}`
                                  : clicked !== item?.Id && !expandAll
                                    ? props?.icon
                                    : `rotate180 ${props?.icon}`
                              }
                             title={(page !== 0 && Array.isArray(clicked) && clicked?.includes(item?.Id)) ? 'Collapse': 'Expand' }
                            ></span>
                          )}{' '}
                          {item?.isExtra && (
                            <span className={props?.extras1Class}>
                              {item?.extras1(item?.title, item?.hideDeleteButton)}
                            </span>
                          )}
                          {props?.headerextras && (
                            <div className={props?.extrasClass}>
                              {props?.headerextras.map((i: any, index: number) => (
                                <>
                                  <div aria-live='polite' className={i?.classq}
                                    tabIndex={0}
                                    title={i.name === 'Templates' ? '' : item?.[i.name] === true
                                    ? 'Yes'
                                    : item?.[i.name] === false ?'No'
                                    : item?.[i.name]}>
                                    <div className={props?.titleclassName}>
                                      {' '}
                                      {i.name === 'Templates' ? '' : i.name}
                                    </div>
                                    <div className={props?.titlecontentclassName}>
                                      {i.name === 'IsArchived'
                                        ? item?.[i.name] === true
                                          ? 'Yes'
                                          : 'No'
                                        : item?.[i.name]}
                                    </div>
                                  </div>
                                  <div className={props?.dividerClass}></div>
                                </>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                          {props?.actions?.map((poclist: any) => (
                            <Buttons
                              aria-label={poclist?.alabel}
                              className={
                                props?.ItemId === item?.Id && poclist.activeClass
                                  ? poclist.activeClass
                                  : poclist?.className
                              }
                              icon={poclist?.icon}
                              key={poclist?.label}
                              label={poclist?.label}
                              onClick={() => {
                                poclist?.onClick(item)
                                setClicked(item?.Id)
                              }}
                            />
                          ))}
                        </div>
                      </div>
                      {props?.isSettings && (clicked === item?.Id || expandAll) && (
                        <div
                          className={
                            props?.inputProps?.contentclassName
                              ? `accordion-content ${props?.inputProps?.contentclassName}`
                              : 'accordion-content'
                          }
                        >
                          {item?.folders
                            ? props?.renderHtml(item?.folders, clicked, index)
                            : props?.renderHtml(item, clicked, index)}
                        </div>
                      )}
                      {item?.content &&
                        (currentPath === detailViewPath || currentPath === createInquiryPath
                          ? Array.isArray(clicked) && clicked?.includes(item?.Id)
                          : clicked === item?.Id || expandAll) && (
                          <div
                            className={
                              props?.inputProps?.contentclassName
                                ? `accordion-content ${props?.inputProps?.contentclassName}`
                                : 'accordion-content'
                            }
                          >
                            {item?.content}
                          </div>
                        )}
                      {props?.content &&
                        (currentPath === detailViewPath || currentPath === createInquiryPath
                          ? (Array.isArray(clicked) && clicked?.includes(item?.Id)) || expandAll
                          : clicked === item?.Id || expandAll) && (
                          <div
                            className={
                              props?.inputProps?.contentclassName
                                ? `accordion-content ${props?.inputProps?.contentclassName}`
                                : 'accordion-content'
                            }
                          >
                            {props?.content}
                          </div>
                        )}
                    </div>
                  )}
              </>
            )
          })
        ) : (
          <div className='min-h-200 d-flex align-items-center justify-content-around'>
            {/* <Noresult /> */}
          </div>
        )}
      </div>
    </div>
  )
}
export default Accordions
